import React, { Component } from 'react';
import '../Modal.css';
import './ModalWin.css';
import x from '../../../shared/assets/modals/x.svg';
import chickGIF from '../../../shared/assets/icons/chick/chick.gif';
import pizzaGIF from '../../../shared/assets/icons/pizza/pizza.gif';
import appleGIF from '../../../shared/assets/icons/apple/apple.gif';
import matchGIF from '../../../shared/assets/icons/match/match.gif';

class ModalWin extends Component {
  get text() {
    if (this.props.level === 4) {return 'You have finished the game!'}
    else {return 'You successfully arranged the animation frames in order!'}
  }

  render() {
    let level = this.props.level;
    let gifs = {
      1: chickGIF,
      2: appleGIF,
      3: matchGIF,
      4: pizzaGIF,
    }
    let gif = gifs[level];

    return (
      <div>
        <div className='backdrop' onClick={this.props.onClick} />
        <div className='modal win-container'>
          <img className='exit' src={x} alt='x' onClick={this.props.onClick} />
          <h1 className='modal-title'>Congratulations!</h1>
          <p className='win-text'>{this.text}</p>
          <img className='win-image' src={gif} alt='finished animation' />

          <button className='modal-button play-again' onClick={this.props.playAgain}>Play Again</button>
          {level !== 4 && <button className='modal-button win-new-game' onClick={this.props.nextLevel}>Next Level</button>}
        </div>
      </div>
    )
  }
}

export default ModalWin;